import DashboardLayout from '../components/Dashboard/Layout/DashboardLayout.vue'
import Login from '@/components/Pages/Login/Login.vue'

// GeneralViews
import ErrorPage from '@/components/shared/404.vue'

// Admin pages
import Overview from '@/views/Overview.vue'
import BookingsList from '@/views/BookingsList.vue'
import InvoicesList from '@/views/InvoicesList.vue'
import TripsList from '@/views/TripsList.vue'
import CreateUser from "../views/CreateUser";
import AffiliatesList from "../views/AffiliatesList";
import Statistics from "@/views/Statistics.vue";
import WidgetPage from "@/views/WidgetPage.vue";
import EmbeddableWidgetPage from "@/views/EmbeddableWidgetPage.vue";
import CreateWhitelabel from '@/views/CreateWhitelabel.vue'
import WalletPage from '@/views/WalletPage.vue'

const routes = [
    {
        path: '/',
        component: DashboardLayout,
        redirect: '/dashboard/overview'
    },
    {
        path: '/home',
        component: Login,
        name: 'home',
        meta: {
          public: true
        }
    },
    {
        path: '/dashboard',
        component: DashboardLayout,
        redirect: '/dashboard/stats',
        meta: {
          public: false
        },
        children: [
            {
                path: 'overview',
                name: 'Overview',
                component: Overview
            },
            {
                path: 'bookings-list',
                name: 'Bookings',
                component: BookingsList
            },
            {
                path: 'invoices',
                name: 'Invoices',
                component: InvoicesList
            },
            {
                path: 'trips-list',
                name: 'Trips',
                component: TripsList
            },
            {
                path: 'statistics',
                name: 'Statistics',
                component: Statistics
            },
            {
                path: 'widget',
                name: 'Widget',
                component: WidgetPage
            },
            {
                path: 'embeddable-widget',
                name: 'EmbeddableWidget',
                component: EmbeddableWidgetPage
            },
            {
                path: 'affiliates/create',
                name: 'CreateUser',
                component: CreateUser
            },
            {
                path: 'affiliates/edit/:code',
                name: 'Affiliate',
                props: true,
                component: CreateUser,
            },
            {
                path: 'affiliates/whitelabel/:code',
                name: 'CreateWhitelabel',
                props: true,
                component: CreateWhitelabel,
            },
            {
                path: 'affiliates',
                name: 'Affiliates',
                component: AffiliatesList,
            },
            {
                path: 'wallet',
                name: 'Wallet',
                component: WalletPage,
            },
        ]
    },
    {path: '/:pathMatch(.*)*', component: ErrorPage}
]



/**
 * Asynchronously load view (Webpack Lazy loading compatible)
 * The specified component must be inside the Views folder
 * @param  {string} name  the filename (basename) of the view to load.
 function view(name) {
   var res= require('../components/Dashboard/Views/' + name + '.vue');
   return res;
};**/

export default routes
